module.exports = __webpack_public_path__ + "static/media/1.160ff352.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy/1.png
// module id = 969
// module chunks = 0